module.exports = __webpack_public_path__ + "static/media/aidb.0027231e.jpg";